import { render } from "./BonusYearDetail.vue?vue&type=template&id=c544495a&scoped=true"
import script from "./BonusYearDetail.vue?vue&type=script&lang=js"
export * from "./BonusYearDetail.vue?vue&type=script&lang=js"

import "./BonusYearDetail.vue?vue&type=style&index=0&id=c544495a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c544495a"

export default script